import { useSearchStore } from './stores/search/useSearchStore';

export const useIsLipaPage = () => {
  const shopIds = useSearchStore((state) => state.shopIds);
  const masterDataShopIds = useSearchStore((state) => state.masterDataShopIds);
  const masterDataLiPaIds = useSearchStore((state) => state.masterDataLiPaIds);
  return Boolean(shopIds?.length || masterDataShopIds?.length || masterDataLiPaIds?.length);
};
